import React, { useEffect, useState, useMemo } from "react";
import MarqueeBar from "../components/home/MarqueeBar";
import PromoGraphic from "../components/home/PromoGraphic";
import GameCard from "../components/home/GameCard";
import GameService from "../services/game.service";
import PromoSpinnerBanner from "../components/common/PromoSpinnerBanner";
import { useLaunch } from "../../auth/useAuth";

const Home = () => {
  const { displayName, navigateToHome } = useLaunch();
  const [homeData, setHomeData] = useState({ layout: [], widgets: {} });
  const [, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchHomeData = async () => {
    try {
      setLoading(true);
      const response = await GameService.getFeaturedGames();
      setHomeData(response?.data || { layout: [], widgets: {} });

    } catch (err) {
      console.error('Error fetching home data:', err);
      setError('Failed to load data. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHomeData();
  }, []);

  const renderSection = (section) => {
    if (!section || !section.type) return null;

    switch (section.type) {
      case 'banners':
        return (
          homeData.widgets.banners?.length > 0 && (
            <PromoGraphic key="banners" data={homeData.widgets.banners} />
          )
        );

      case 'game':
        return (
          <div key="games" className="grid grid-cols-2 gap-4">
            {homeData.widgets.game?.length > 0 ? (
              homeData.widgets.game.map((game, index) => (
                <GameCard
                  key={index}
                  image={game.tileImageUrl}
                  alt={game.displayName}
                  gameName={game.gameName}
                />
              ))
            ) : (
              <p className="text-center text-redShade1 col-span-2">No games available</p>
            )}
          </div>
        );

      case 'winner_ticker':
        return (
          homeData.widgets.winner_ticker?.length > 0 && (
            <MarqueeBar key="winners" data={homeData.widgets.winner_ticker} />
          )
        );

      case 'spin_wheel':
        return (
            <PromoSpinnerBanner
              key="spin-wheel"
              leftImage={'/assets/images/games/leftimage.png'}
              rightImage={'/assets/images/games/rightimage.png'}
              title="WIN FREE TICKETS DAILY"
            />
          )

      default:
        return null;
    }  
  };

  // Use layout array as-is for rendering order
  const layoutToRender = useMemo(() => {
    return homeData.layout || [];
  }, [homeData.layout]);

  if (error) {
    return <div className="text-redShade1 text-center p-4">{error}</div>;
  }

  return (
    <div className="space-y-4 sm:space-y-6 pt-0 sm:pt-3">
      {layoutToRender.map((section, index) => (
        <React.Fragment key={`${section.type}-${index}`}>
          {renderSection(section)}
        </React.Fragment>
      ))}

      {/* Username & Lobby link */}
      <div className="flex flex-col items-center gap-0 pb-6">
        <span className="auth-label text-white">
          {displayName || 'Guest'}
        </span>
        {navigateToHome && (
          <button
            onClick={navigateToHome}
            className="auth-label"
            style={{ color: '#666666' }}
          >
            Back to Lobby
          </button>
        )}
      </div>
    </div>
  );
};

export default Home;
